import { Button, Checkbox, Col, Input, message, Popconfirm, Row } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

function BackupVisaPersonalFunction(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [messageApi, contextHolder] = message.useMessage();

  // const [row, setRow] = useState('1');
  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('');

  const [needVerifyPayment, setNeedVerifyPayment] = useState(true);
  const [cancelAfterVerify, setCancelAfterVerify] = useState(true);
  const [manual, setManual] = useState(false);
  const [quantity, setQuantity] = useState('5');

  const create = async (profile) => {
    if(!sheetURL || !sheetName) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`Profile: ${profile.name} >>> Backup VISA TKCN...`);
    let body = {
      profile: profile,
      needVerifyPayment,
      cancelAfterVerify,
      manual,
      quantity,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      }
    };
    axios
      .post(`${API_HOST}/api/account/backup-visa-personal`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ add-acct-full ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let needVerifyPayment = localStorage.getItem('ba-vi-tkcn-needVerifyPayment')
    if(needVerifyPayment) {
      setNeedVerifyPayment(needVerifyPayment == 'true')
    }
    let cancelAfterVerify = localStorage.getItem('ba-vi-tkcn-cancelAfterVerify')
    if(cancelAfterVerify) {
      setCancelAfterVerify(cancelAfterVerify == 'true')
    }

    let sheetName = localStorage.getItem('ba-vi-tkcn-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('ba-vi-tkcn-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
    let quantity = localStorage.getItem('ba-vi-tkcn-quantity')
    if(quantity) {
      setQuantity(quantity)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Backup VISA TKCN"
        description={
          <div style={{ width: '500px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}

            <Checkbox checked={needVerifyPayment} onChange={e => {
              setNeedVerifyPayment(e.target.checked);
              localStorage.setItem('ba-vi-tkcn-needVerifyPayment', `${e.target.checked}`)
            }}>
              Xác Minh Thẻ
            </Checkbox>
            <br />
            <Checkbox checked={manual} onChange={e => setManual(e.target.checked)}>
              Lấy CODE Thủ Công
            </Checkbox>
            <br />
            <Checkbox checked={cancelAfterVerify} onChange={e => {
              setCancelAfterVerify(e.target.checked);
              localStorage.setItem('ba-vi-tkcn-cancelAfterVerify', `${e.target.checked}`)
            }}>
              Hủy TK Sau Khi Xác Minh
            </Checkbox>
            <br />

            <b>Data GG sheet: </b>
            <Row>
              <Col span={4}>
                <label>SL Max: </label>
              </Col>
              <Col span={20}>
                <Input
                  style={{ width: '200px' }}
                  value={quantity}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value);
                    localStorage.setItem('ba-vi-tkcn-quantity', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={20}>
               <Input
                  value={sheetURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('ba-vi-tkcn-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={20}>
                 <Input
                    value={sheetName}
                    style={{ width: 200 }}
                    placeholder="Visa USA..."
                    onChange={(e) => {
                      setSheetName(e.target.value);
                      localStorage.setItem('ba-vi-tkcn-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button><b>Backup VISA TKCN</b></Button>
      </Popconfirm>
    </>
  );
}
export default BackupVisaPersonalFunction;
